// import 'CSSEscape'
const unescapeBackslash = (str: string) => str.replace(/(\\.)/g, (s: string) => s.slice(1)).replace(/(\\[$\-+/():!^&'~{}<>= ])/g, (s: string) => s.slice(1));
const RegularExpressions = {
    CSS: {
        Sequence: (function () {
            const o: any = /\\((([\dA-F]{2}|[\dA-F]{1,5})\s)|([\dA-F]{6}|[\dA-F]{4}))/gim;
            o.unescape = function (s: any) {
                const f = String.fromCharCode;
                const i = parseInt;
                return s.replace(this, (c: any) => f(i(c.slice(2), 16)));
            };
            return o;
        }()),
    },
};

const escapeCssSequenceWithoutQuotation = (str: string) => {
    let index = 0;
    str = str.split('"').map((s) => {
        index += 1;
        if (index % 2 === 0) {
            return s;
        }
        return s.replace(/([\\)|(#;,.[\]$¥])/g, '\\$1')
            .replace(/(\\¥)/g, '\\$1');
    })
        .join('\\0022');
    return str;
};

const unEscapeCssSequence = (str: string) => unescapeBackslash(RegularExpressions.CSS.Sequence.unescape(str));
const escapeCssSequence = (str: string) => {
    const replaced = escapeCssSequenceWithoutQuotation(str);
    return `'${replaced}'`;
};

export { unEscapeCssSequence, escapeCssSequence };
